<div style="height: 100%">
  <div class="form-panel-wrapper">
    <div class="row form-row m-0 p-4">
      <div class="row">
        <label
          class="first-label"
          [innerHTML]="'User::ImportFromFileInfo' | abpLocalization"></label>
      </div>

      <div class="row">
        <div class="step-item">
          <div class="first">
            <button
              (click)="csvFile.click()"
              class="btn ca-btn ca-btn-neutral-toolbar toolbar-button">
              <i class="far fa-upload"></i>
              <span>{{ 'User::UploadFile' | abpLocalization }}</span>
            </button>
            <input
              id="csvFile"
              [hidden]="true"
              type="file"
              (click)="$event.target.value = ''"
              (change)="onFileChange($event.target.files)"
              accept="{{ acceptFileExtensions.join(',') }}"
              #csvFile />
          </div>

          <div class="second">
            <button
              class="btn ca-btn ca-btn-neutral-toolbar toolbar-button"
              (click)="downloadExampleFile()">
              <i class="far fa-download"></i>
              <span>{{ 'User::ExampleFile' | abpLocalization }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="row mt-2 mb-2">
        <div class="col-12 truncate-text" *ngIf="selectedCsvFile?.size > 0">
          <b>
            {{ selectedCsvFile?.name + ',' + (selectedCsvFile.size / 1024).toFixed(2) + ' KB' }}
          </b>
        </div>
      </div>
    </div>
  </div>
  <div class="row submenu-row bottom-toolbar-row" style="border-bottom-width: 0px !important">
    <div class="col ps-2 pe-2">
      <div class="text-lg-right ca-toolbar" id="AbpContentToolbar">
        <div class="ca-toolbar-east-section pe-2">
          <div class="toolbar-item">
            <button type="button" class="btn ca-btn ca-btn-neutral" (click)="closePanel()">
              {{ 'AbpUi::Cancel' | abpLocalization }}
            </button>
          </div>
          <div class="toolbar-item last">
            <button class="btn ca-btn ca-btn-primary" type="button" (click)="onImportFromFile()">
              <span>{{ 'User::Import' | abpLocalization }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
